module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"staff_review":"관리자 리뷰","my_review":"내 리뷰"}}')
  delete Component.options._Ctor
}
